export default __webpack_public_path__ + "static/media/blogs.4a469efb.svg";